import React, { PropsWithChildren } from 'react';
import { ErrorBoundary, ErrorBoundaryPropsWithComponent } from 'react-error-boundary';

import { withSentryHub } from '../services/sentry-service';

export type SentryErrorBoundaryProps = PropsWithChildren<ErrorBoundaryPropsWithComponent>;

const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({
  children,
  FallbackComponent,
  onReset,
}) => {
  const handleError = (error: Error) => {
    // 1- Simple approach : capture error with no tag
    // ------------------------
    withSentryHub().captureException(error);
    // ------------------------
    // 2- Approach adding a tag
    // ------------------------
    // withSentryHub().captureException(error, {
    //   // If you need to send things specific to this error on top of the
    //   // error itself then use this captureContext
    //   captureContext: (scope) => scope.setTags({ type: 'errorBoundary' }),
    // });
    // ------------------------
  };

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent} onError={handleError} onReset={onReset}>
      {children}
    </ErrorBoundary>
  );
};

export default SentryErrorBoundary;
